import React from 'react'

const TransactionsStatusBadgeType = ({status}) => {
  return (
    <div  className={` status-badge  status-type-${status}`}>
        {status}
    </div>
  )
}

export default TransactionsStatusBadgeType     